import React from 'react';
import { Box, useTheme } from '@mui/material';
import SuperAdminSidebar from './SuperAdminSidebar';
import { LAYOUT } from '../../../constants/layout';

interface SuperAdminLayoutProps {
  children: React.ReactNode;
}

const SuperAdminLayout: React.FC<SuperAdminLayoutProps> = ({ children }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex' }}>
      <SuperAdminSidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: `calc(100% - ${LAYOUT.DRAWER_WIDTH}px)`,
          minHeight: '100vh',
          backgroundColor: theme.palette.background.default,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default SuperAdminLayout;
